import { UNMOVED_HIGHLIGHT_FADE_MS, UNMOVED_HIGHLIGHT_HOLD_MS } from "#/game/animation/constants";

export function unmovedHighlightOpacity({
  fadeStartedAtMs,
  nowMs,
}: {
  fadeStartedAtMs: number | null;
  nowMs: number;
}): number {
  if (fadeStartedAtMs === null) return 1;
  const elapsed = nowMs - fadeStartedAtMs;
  if (elapsed < UNMOVED_HIGHLIGHT_HOLD_MS) return 1;
  const fadeElapsed = elapsed - UNMOVED_HIGHLIGHT_HOLD_MS;
  if (fadeElapsed >= UNMOVED_HIGHLIGHT_FADE_MS) return 0;
  return 1 - fadeElapsed / UNMOVED_HIGHLIGHT_FADE_MS;
}

export function isUnmovedHighlightAnimating({
  fadeStartedAtMs,
  nowMs,
}: {
  fadeStartedAtMs: number | null;
  nowMs: number;
}): boolean {
  if (fadeStartedAtMs === null) return false;
  return nowMs < fadeStartedAtMs + UNMOVED_HIGHLIGHT_HOLD_MS + UNMOVED_HIGHLIGHT_FADE_MS;
}
